import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { SET_ACTIVE_RESOURCE } from 'constants/actionTypes';

import Breadcrumb from 'react-bootstrap/Breadcrumb';

export default function ResourceNavigation() {
  const dispatch = useDispatch();

  const active = useSelector(state => state.modal.active);
  const resources = useSelector(state => state.modal.resources);

  return (
    <Breadcrumb>
      {
        resources.map((resource, key) => (
          <Breadcrumb.Item 
            key={key}
            active={key === active}
            onClick={() => dispatch({type: SET_ACTIVE_RESOURCE, index: key}) }
          >
            {resource.label}
          </Breadcrumb.Item>
        ))
      }
    </Breadcrumb>
  );
}